import type { Component } from 'solid-js'
import type { ChannelData } from '../../../features/engagement/domain/models/chat'
import ValueProgressCell from './custom-cells/ValueProgressCell'
import { KPI, KPIType } from '../../../features/analytics/domain/models/kpi'
import { NumericalDataType } from '../../../shared/models/numerical-data-type'

export interface ChatRoomsTableRowProps {
  readonly channel: ChannelData
  readonly rowNumber: number
}

const ChatRoomsTableRow: Component<ChatRoomsTableRowProps> = (props) => {
  const messagesKPI = () =>
    new KPI(
      KPIType.Messages,
      props.channel.messages.current,
      NumericalDataType.Units,
      props.channel.messages.diff,
      props.channel.messages.previous
    )

  const uniqueChattersKPI = () =>
    new KPI(
      KPIType.UniqueChatters,
      props.channel.uniqueChatters.current,
      NumericalDataType.Units,
      props.channel.uniqueChatters.diff,
      props.channel.uniqueChatters.previous
    )

  return (
    <tr class="hover:bg-gray-50">
      <td class="whitespace-nowrap border-r border-gray-200 text-center text-sm text-gray-700">{props.rowNumber}</td>
      <td class="w-full font-medium text-gray-900">
        <span>{props.channel.name}</span>
      </td>
      <td class="w-[188px]">
        <ValueProgressCell kpi={messagesKPI()} />
      </td>
      <td class="w-[188px]">
        <ValueProgressCell kpi={uniqueChattersKPI()} />
      </td>
    </tr>
  )
}

export default ChatRoomsTableRow
